import type { PropsWithChildren } from "react";

import styled from "styled-components";

import { Flex, Box } from "@similarweb/ui-components/foundations";
import { TableWrapper } from "app/pages/keyword-research/keyword-analysis/common-components/domains-table/Table";

export const MetricsRow = styled(Flex)`
    margin-top: 24px;
    ${TableWrapper} {
        width: 100%;
    }
`;

const MetricContainerWrapper = styled(Box)<{
    width?: string;
    height?: string;
    minHeight?: string;
    padding?: string;
    overflow?: string;
}>`
    ${({ width = "33.3%" }) => `width:${width}`};
    ${({ height = "189px" }) => `height:${height}`};
    ${({ minHeight }) => minHeight && `min-height: ${minHeight};`};
    ${({ padding = "24px" }) => `padding:${padding}`};
    background-color: white;
    @media (max-width: 1400px) {
        ${({ padding = "16px" }) => `padding:${padding}`};
    }
    ${({ overflow = "hidden" }) => `overflow:${overflow}`};
`;

type MetricContainerProps = PropsWithChildren<{
    width?: string;
    height?: string;
    minHeight?: string;
    padding?: string;
    overflow?: string;
}>;

const MetricContainer = ({ children, ...rest }: MetricContainerProps) => {
    return (
        <MetricContainerWrapper {...rest}>
            <div style={{ position: "relative", height: "100%" }}>{children}</div>
        </MetricContainerWrapper>
    );
};

export const MetricContainerStyled = styled(MetricContainer)`
    display: flex;
    flex-grow: 1;
    position: relative;

    > div {
        width: 100%;
    }
`;
